var React = require('react');

function APlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 0v13c0 3.419-5.247 3.745-8.256 3 0 0 1.522 8-3.335 8h-8.409v-24h20zm-6.091 18.223c2.047.478 4.805-.279 6.091-1.179-1.494 1.997-5.231 5.707-7.432 6.881 1.155-1.168 1.563-4.234 1.341-5.702zm-4.909-1.223h-5v1h5v-1zm0-2h-5v1h5v-1zm7-2h-12v1h12v-1zm0-2h-12v1h12v-1zm-7.309-3.485l-2.055.002-.39 1.172-1.246.001 2.113-5.689 1.086-.001 2.133 5.686-1.246.001-.395-1.172zm4.373-2.014l1.41-.001.001 1.019-1.41.001.001 1.594-1.074.001-.001-1.594-1.414.001-.001-1.02 1.414-.001-.001-1.527 1.074-.001.001 1.528zm-6.112 1.066l1.422-.001-.717-2.128-.705 2.129z"}));
}

APlusInline.defaultProps = {"width":"128","height":"128","fillRule":"evenodd","clipRule":"evenodd","viewBox":"0 0 24 24"};

module.exports = APlusInline;

APlusInline.default = APlusInline;
